import CONSTANTS from '../CONSTANTS';

export const actionGetKitEditorStatus = () => ({
  type: CONSTANTS.KITS_GET_REMOTE_STATE
});

export const actionSetKitEditorStatus = (status) => ({
  type: CONSTANTS.KITS_SET_LOCAL_STATE,
  status
});

export const actionSetRemoteKitEditorStatus = (status) => ({
  type: CONSTANTS.KITS_SET_REMOTE_STATE,
  status
});